export const createHeaders = (token, eTag = null) => {
  const headers = { Authorization: `Bearer ${token}` };
  return eTag ? { ...headers, "If-Match": eTag } : headers;
};
